import { Box, Spinner } from '@lego/klik-ui';

export const Loader = () => {
  return (
    <Box padding={8}>
      <Spinner margin={'auto'} />
    </Box>
  );
};
